// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".JobCompletionBadge-empty__DxGiJ{color:var(--gray-a11)}.JobCompletionBadge-inProgress__NHwhx{color:var(--blue-a11)}.JobCompletionBadge-complete__EAywS{color:var(--jade-a11)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"empty": "JobCompletionBadge-empty__DxGiJ",
	"inProgress": "JobCompletionBadge-inProgress__NHwhx",
	"complete": "JobCompletionBadge-complete__EAywS"
};
export default ___CSS_LOADER_EXPORT___;
